import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M13.76 18.25L12.34 16.8289L16.15 13.0058H4V10.9942H16.15L12.34 7.17114L13.76 5.75L20 11.995L13.76 18.25Z" fill={ fill || 'currentColor' }/>
    </svg>
);
